export const actionIconDefaultProps = {
  size: 'medium',
  interactive: true
};